/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'No-Image': {
    width: 16,
    height: 16,
    viewBox: '0 0 65 12',
    data: '<text fill="#999" fill-rule="evenodd" font-family="NotoSansCJKjp-Medium, Noto Sans CJK JP" font-size="14" font-weight="400"><tspan x="-1" y="11">NO IMAGE</tspan></text>'
  }
})
